<template>
  <div class="mt-8 flex justify-end px-24 pb-24">
    <BrandedPaymentSubmitButton :form />
  </div>
</template>

<script setup lang="ts">
import type { PaymentFormInstance } from '../../../form-common/types/PaymentFormInstance'

import BrandedPaymentSubmitButton from './BrandedPaymentSubmitButton.vue'

defineProps<{
  form: PaymentFormInstance | null
}>()
</script>
